import React, { useEffect, useState } from "react";
import { useNavigate, Link, useLocation, } from 'react-router-dom';
import HistoryIcon from '@mui/icons-material/History';
import JobAssignHistoryModal from "./JobAssignHistoryModal";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import { dsQuery } from "./query";
import JobAssignDatasheet from "./jobAssignDatasheet";
import { fetchUserOptions, fetchUsers, handleUserAssign } from "./fetchHandler";
import VisibilityIcon from '@mui/icons-material/Visibility';
import SendIcon from '@mui/icons-material/Send';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { getPermissions } from "../rbac/hasAccess";
import { Autocomplete, TextField, Tooltip } from "@mui/material";
import { observationSheetApprove, sendForApproval } from "./submitHandler";
import { DateisValid } from "../../utils/commonComponent/errorAlert";

const getBackgroundColor = (row) => {
  if (row?.observationSheet_totalReadings && row?.observationSheet_totalReadings != 0) return '#22c9b0';
  // if (row?.observationSheet_approvedBy) return '#22c9b0'; //
  return ''; // Default color if no other field is set
};

const getTooltipText = (row) => {
  if (row.observationSheet_testedBy) return row.testedBy_userName ? `Tested By ${row.testedBy_userName}` : 'Tested By';
  return ''; // No tooltip text if none are found
};

const headers = ["id", "customerName", "materialName", "testName", "jobNumber", "labReferenceNo", "testNumber", "ULRNo", "ReportNo", "assign",];

const fields = [
  { value: "inward.customerName", label: "Customer Name" },
  { value: "materialScope.MaterialName", label: "Material Name" },
  { value: "materialTestings.testName", label: "Test Name" },
  { value: "jobRegister.jobNumber", label: "Job Number" },
  { value: "inward.labReferenceNo", label: "Lab Reference No." },
  { value: "observationSheet.testNumber", label: "Test No." },
  { value: "observationSheet.ulrNumber", label: "ULR No." },
  { value: "observationSheet.reportNumber", label: "Report No." },
];

// Mapping between headers and SQL result fields
const fieldMap = {
  jobNumber: "jobRegister_jobNumber",
  labReferenceNo: "inward_labReferenceNo",
  customerName: "inward_customerName",
  materialName: "materialScope_MaterialName",
  testName: "materialTestings_testName",
  testNumber: "observationSheet_testNumber",
  ULRNo: "certificate_ulrNumber",
  ReportNo: "certificate_reportNumber",
  assign: "observationSheet_jobAssignedUser",
};

const DatasheetList = (props) => {
  const navigate = useNavigate();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/editdatasheet/${row?.id}`);
  const location = useLocation();
  const [filterFromDashboard, setFilterFromDashboard] = useState(location.state?.filter || null);
  const [searchBy, setSearchBy] = useState(sessionStorage.getItem("searchBy") || "observationSheet.testNumber");
  const [searchKey, setSearchKey] = useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = useState(sessionStorage.getItem("searched") === "true" || false);
  const [userList, setUserList] = useState([]);
  const [datasheetList, setDatasheetList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [jobAssignIds, setJobAssignIds] = useState([]);
// ── Shared user options ────────────────────────────────────────────────────
  const [userOptions, setUserOptions] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  // const [showJobAssign, setShowJobAssign] = useState(false);
  const _userType = Number(localStorage.getItem("type"));
  const _userId = Number(localStorage.getItem("id"));
  const _groupId = localStorage.getItem("groupId");
  // job assign history
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyRow, setHistoryRow] = useState(null);

  const jobAssignShow = [1, 2, 4, 12].includes(_userType) || [3, 4].includes(props.rolesInfo?.currentRole?.id); 

  // Pagination states
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const getQuery = (count = false, labRefId) => {
    let whereConditions = "WHERE 1=1 AND observationSheet.status = 1";
    const groupBy = "GROUP BY observationSheet.id";
    let pagination_settings = "";

    if (searchBy && searchKey) {
      whereConditions += ` AND LOWER(${searchBy}) LIKE LOWER('%${searchKey}%')`;
    }

    if (labRefId) {
      whereConditions += ` AND inward.id = ${labRefId}`;
    }

    // If user type is 4, only show records assigned
    if (_userType == 4 && filterFromDashboard) {
      if (filterFromDashboard === "Assigned Test") {
        whereConditions += ` AND observationSheet.jobAssignedUser = ${_userId}`;
      } else if (filterFromDashboard === "Pending Test") {
        whereConditions += ` AND observationSheet.jobAssignedUser = ${_userId} AND (observationSheet.totalReadings IS NULL OR observationSheet.totalReadings = 0)`;
      } else if (filterFromDashboard === "Completed Test") {
        whereConditions += ` AND observationSheet.jobAssignedUser = ${_userId} AND observationSheet.totalReadings > 0`;
      }
    }

    // If user type is 4, only show records assigned to engineer
    if (_userType == 4) {
      whereConditions += ` AND (observationSheet.jobAssignedUser = ${_userId} OR inward.createdBy = ${_userId})`;
    }

    // If groupId available
    if (_groupId && _groupId != 'null') {
      const groupIds = _groupId.split(',');
      const groupConditions = groupIds.map(id => `FIND_IN_SET(${id.trim()}, inwardTests.groupId)`).join(' OR ');
      whereConditions += ` AND (${groupConditions} OR inwardTests.id IS NULL OR inwardTests.groupId IS NULL OR inwardTests.groupId = '')`;
    }

    if (count) {
      return `SELECT COUNT(*) AS no_of_rows FROM (${dsQuery} ${whereConditions} ${groupBy}) AS count_table;`;
    }

    // Add pagination to query
    const offset = currentPage * rowsPerPage;
    pagination_settings = `LIMIT ${rowsPerPage} OFFSET ${offset}`;

    return `${dsQuery} ${whereConditions} ${groupBy} ORDER BY observationSheet.id DESC ${pagination_settings};`;
  };

  const fetchData = async (labRefId = null) => {
    try {
      const query = getQuery(false, labRefId);
      const result = await fetchQuery(query);

      const countQuery = getQuery(true);
      const countResult = await fetchQuery(countQuery);
      setTotalRecords(countResult[0]?.no_of_rows || 0);

      const mappedData = result.map((row) => {
        // Build display data
        const displayFields = {};
        headers.forEach((header) => {
          if (header === "assign") {
            // Map user ID to userName
            const user = userList.find((u) => u.id == row?.observationSheet_jobAssignedUser);
            displayFields[header] = user ? `${user.employeeName || "-"}${user.userName ? ` (${user.userName})` : ""}` : "-";
          } else {
            displayFields[header] = row[fieldMap[header]] ?? "-";
          }
        });

        // Merge with full row data, preserving everything
        return {
          ...displayFields,
          ...row, // full raw data
        };
      });

      setDatasheetList(mappedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
    fetchData();
    setSearched(true);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("observationSheet.testNumber");
    setSearchKey("");
    fetchData();
    setFilterFromDashboard(null);
    // Clear all datasheet list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
    navigate("/datasheetList", { replace: true });
  };

  // Pagination logic
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
      sessionStorage.setItem("currentPath", location.pathname);
      sessionStorage.setItem("ListPageCount", newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
    sessionStorage.setItem("ListRowsPerPage", e.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const handleSelectRow = (id) => {
    const updated = selectedIds.includes(id)
      ? selectedIds.filter((item) => item !== id)
      : [...selectedIds, id];
    setSelectedIds(updated);
  };

  // ===== handleSelectAll =====
  const handleSelectAll = () => {
    // Filter rows that are eligible for selection
    const selectableRows = datasheetList.filter(row => row.observationSheet_testedBy);
    const selectableIds = selectableRows.map(row => row.id);

    if (selectedIds.length === selectableIds.length) {
      // Unselect all
      setSelectedIds([]);
    } else {
      // Select only eligible rows
      setSelectedIds(selectableIds);
    }
  };

  const isAllSelected = selectedIds.length === datasheetList.length && datasheetList.length > 0;

  // Callback for child to update datasheetList by labRef
  const handleLabRefSelect = (labRef) => {
    const labRefId = labRef?.id || null; // if null, fetch all
    fetchData(labRefId);
  };

  const handleJobAssignSelectRow = (id) => {
    const updated = jobAssignIds.includes(id)
      ? jobAssignIds.filter((item) => item !== id)
      : [...jobAssignIds, id];
    setJobAssignIds(updated);
  };
  const handleJobAssignSelectAll = () => {
    const allIds = datasheetList.map(row => row.id);

    if (jobAssignIds.length === allIds.length) {
      setJobAssignIds([]);
    } else {
      setJobAssignIds(allIds);
    }
  };

  const isAllJobAssignSelected =
    jobAssignIds.length === datasheetList.length && datasheetList.length > 0;
    
  useEffect(() => {
    fetchUsers().then((users) => {
      setUserList(users);
      fetchData();
    });
     fetchUserOptions(setUserOptions);
  }, []);

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (filterFromDashboard) {
      fetchData();
      setSearched(true);
    }
  }, [filterFromDashboard]);

  useEffect(() => {
    if (!searched) {
      fetchData();
    }
  }, [searched, userList]);

  return (
    <>
      <ListSearchSection
        title="Search ObservationSheet"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
        // extraButton={true}
        // extraButtonLable="Job Assign"
        // onJobAssignClick={() => setShowJobAssign(!showJobAssign)}
        // jobAssignShow={jobAssignShow}
      />

      {selectedIds.length > 0 && props.rolesInfo?.currentRole?.id == 4 && (
        <div className="flex justify-start my-3">
          <button
            onClick={() => observationSheetApprove(selectedIds)}
            className="bg-[#22c9b0] text-white px-4 py-2 rounded-md hover:bg-[#0d9a85]"
          >
            Approved
          </button>
        </div>
      )}

      {jobAssignIds.length > 0 && jobAssignShow && (
        <div className="flex justify-start my-3">
          <Autocomplete
            size="small"
            sx={{ width: 220 }}
            options={userOptions.filter((user) => user.id != Number(localStorage?.getItem?.("id") || 0))}
            onChange={(e, newValue) => {
              handleUserAssign(newValue, jobAssignIds);
            }}
            renderOption={(props, option) => (
              <li {...props} style={{ color: option.label.startsWith("Withdraw Job") ? "red" : "inherit", }}>
                {option.label}
              </li>
            )}
            getOptionLabel={(option) => option?.label || ""}
            renderInput={(params) => <TextField {...params} label="Assign User" />}
          />
        </div>
      )}

      {/* {showJobAssign && (
        <JobAssignDatasheet
          datasheetList={datasheetList}
          _userType={_userType}
          showJobAssign={handleLabRefSelect}
          onJobAssignClick={() => setShowJobAssign(!showJobAssign)}
           selectedIds={jobAssignIds}
           userOptions={userOptions}
           onUserSelect={handleUserAssign}
        />
      )} */}

      <div className="w-full border rounded-md shadow">
        {/* Table Container */}
        <div className="overflow-y-auto h-auto max-h-[400px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs uppercase font-medium text-gray-600 z-10">
              <tr>
                {props.rolesInfo?.currentRole?.id == 4 && (
                  <th className="px-2 py-3 text-center">
                    <div className="flex flex-col items-center justify-center">
                      <span className="text-[10px] normal-case font-medium text-black whitespace-nowrap">
                        Approve
                      </span>
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={handleSelectAll}
                      />
                    </div>
                  </th>
                )}
                {jobAssignShow && (
                  <th className="px-2 py-3 text-center">
                    <div className="flex flex-col items-center justify-center">
                      <span className="text-[10px] normal-case font-medium text-black whitespace-nowrap">
                        Job Assign
                      </span>
                      <input
                        type="checkbox"
                        checked={isAllJobAssignSelected}
                        onChange={handleJobAssignSelectAll}
                      />
                    </div>
                  </th>
                )}
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Sr. No.</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Customer Name</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Material Name</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Test Name</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Job Number</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Lab Ref No</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Test No</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">ULR No</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Report No</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Start Date</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">End Date</th>
                <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Assign</th>
                {(permissions.view || permissions.edit || permissions.allAccess) && (
                  <th className="px-4 py-3 text-center whitespace-nowrap capitalize">Actions</th>
                )}
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {datasheetList.map((row, index) => {
                return (
                  <tr key={row.id} className="hover:bg-gray-50">
                    {props.rolesInfo?.currentRole?.id == 4 && (
                      <td className="px-2 py-2 text-center">
                        <input
                          type="checkbox"
                          checked={selectedIds.includes(row.id)}
                          onChange={() => handleSelectRow(row.id)}
                          disabled={row?.observationSheet_testedBy == null}
                        />
                      </td>
                    )}
                    {jobAssignShow && (
                      <td className="px-2 py-2 text-center">
                        <input
                          type="checkbox"
                          checked={jobAssignIds.includes(row.id)}
                          onChange={() => handleJobAssignSelectRow(row.id)}
                        />
                      </td>
                    )}
                    <td className="px-4 py-2 text-center">{currentPage * rowsPerPage + index + 1}</td>
                    <td className="px-4 py-2 text-center truncate-text">{row.inward_customerName || '-'}</td>
                    <Tooltip title={getTooltipText(row)} placement="top">
                      <td className="px-4 py-2 text-center" style={{ backgroundColor: getBackgroundColor(row) }}>
                        <Link to={`/editdatasheet/${row.id}`} className="hover:text-blue-600">
                          {row.materialScope_MaterialName || '-'}
                        </Link>
                      </td>
                    </Tooltip>
                    <Tooltip title={getTooltipText(row)} placement="top">
                      <td className="px-4 py-2 text-center truncate-text" style={{ backgroundColor: getBackgroundColor(row) }}>
                        <Link to={`/editdatasheet/${row.id}`} className="hover:text-blue-600">
                          {row.materialTestings_testName || '-'}
                        </Link>
                      </td>
                    </Tooltip>
                    <td className="px-4 py-2 text-center">{row.jobRegister_jobNumber || '-'}</td>
                    <td className="px-4 py-2 text-center">{row.inward_labReferenceNo || '-'}</td>
                    <Tooltip title={getTooltipText(row)} placement="top">
                      <td className="px-4 py-2 text-center" style={{ backgroundColor: getBackgroundColor(row) }}>
                        <Link to={`/editdatasheet/${row.id}`} className="hover:text-blue-600">
                          {row.observationSheet_testNumber || '-'}
                        </Link>
                      </td>
                    </Tooltip>
                    <td className="px-4 py-2 text-center">{row.certificate_ulrNumber || '-'}</td>
                    <td className="px-4 py-2 text-center">{row.certificate_reportNumber || '-'}</td>
                    <td className="px-4 py-2 text-center">{DateisValid(row.observationSheet_startTestingDate)}</td>
                    <td className="px-4 py-2 text-center">{DateisValid(row.observationSheet_endTestingDate)}</td>
                    <td className="px-4 py-2 text-center">{row.assign || '-'}</td>
                    <td className="px-4 py-2 text-center">
                      <div className="flex items-center justify-center gap-2">
                        {(permissions.edit || permissions.allAccess) && (
                          <Tooltip title="Edit Datasheet" placement="top">
                          <button
                            onClick={() => navigate(`/editdatasheet/${row?.id}`)}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <EditIcon fontSize="small" />
                          </button>
                          </Tooltip>
                        )}

                          <Tooltip title="Send For Approval" placement="top">
                          <button
                            onClick={() => sendForApproval(row?.id, row)}
                            className="text-blue-600 hover:text-blue-800 disabled:opacity-50"
                            disabled={row.observationSheet_requestApproval == 1}
                          >
                            <SendIcon fontSize="small" />
                          </button>
                          </Tooltip>

                        {(permissions.view || permissions.allAccess) && (
                          <Tooltip title="View Datasheet" placement="top">
                            <button
                              onClick={() => navigate(`/viewdatasheet/${row?.id}`)}
                              className="text-blue-600 hover:text-blue-800"
                            >
                              <VisibilityIcon fontSize="small" />
                            </button>
                          </Tooltip>
                        )}
                        <Tooltip title="Job Assign History" placement="top">
                          <button
                            onClick={() => {
                              setHistoryRow(row);
                              setHistoryOpen(true);
                            }}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <HistoryIcon fontSize="small" />
                          </button>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })}

              {datasheetList.length === 0 && (
                <tr>
                  <td
                    colSpan={headers.length + 3}
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between gap-2 px-2 py-2 bg-blue-50 text-xs sm:text-sm border-t overflow-x-auto whitespace-nowrap">
          <div className="flex items-center gap-1">
            <span>Rows Per Page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-1 py-0.5 text-xs sm:text-sm"
            >
              {[30, 50, 100].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-1">
            <span className="text-gray-600 hidden sm:inline">
              {totalRecords === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRecords
                )} of ${totalRecords}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>

      <JobAssignHistoryModal
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        row={historyRow}
        permissions={permissions}
      />
    </>
  );
};

export default DatasheetList;